import type { SyntheticEvent} from 'react';
import React, {Fragment} from 'react'
import {lazyProp} from '../helpers/react-helpers'
import ActionLink from './ActionLink'
import Slider from './Slider'
import fromPairs from 'lodash/fromPairs'
import DollarBox from './DollarBox'
import {arraySum} from '../util/collections'
import {parseFloat} from '../util/math'
import {resolveRoute} from '../helpers/ajax'

function toCents(amount: any) {
    return Math.round(parseFloat(amount, 0) * 100);
}

type Props = {
    bookings?: any[];
    setAlloc?: (...args: any[]) => any;
    getAlloc?: (...args: any[]) => any;
    chargeAmount?: number;
};

export default class PaymentAllocation extends React.Component<Props> {
    props: Props
    allocDiff: any;
    totalAlloc: any;

    constructor(props: any) {
        super(props);

        lazyProp.call(this, 'totalAlloc', [(s: any, p: any) => p.alloc], (alloc: any) => (arraySum(Object.values(alloc).map(v => Math.round(parseFloat(v, 0) * 100))) / 100).toFixed(2));
        lazyProp.call(this, 'allocDiff', ['totalAlloc', (s: any, p: any) => p.chargeAmount], (alloc: any, amount: any) => (amount - alloc).toFixed(2))
    }

    payDist = (ev: SyntheticEvent) => {
        const totalDue = arraySum(this.props.bookings.map((bk: any) => bk.total_due_value));
        const percents = this.props.bookings.map((bk: any) => [bk.id, totalDue > 0 ? bk.total_due_value / totalDue : 0]);
        this.props.setAlloc(fromPairs(percents.map(([id, pc]) => [id, (pc * this.props.chargeAmount).toFixed(2)])));
    }

    payFill = (ev: SyntheticEvent) => {
        let remaining = this.props.chargeAmount;
        const alloc = {};
        for (const bk of this.props.bookings) {
            const amount = Math.min(remaining, bk.total_due_value);
            remaining -= amount;
            alloc[bk.id] = amount.toFixed(2);
        }
        this.props.setAlloc(alloc);
    }

    paySplit = (ev: SyntheticEvent) => {
        const amount = this.props.chargeAmount / this.props.bookings.length;
        const alloc = {};
        for (const bk of this.props.bookings) {
            alloc[bk.id] = Math.min(amount, bk.total_due_value).toFixed(2);
        }
        this.props.setAlloc(alloc);
    }

    render() {
        const {bookings, setAlloc, getAlloc, chargeAmount} = this.props;

        return (
            <Fragment>

                <div>
                    <label style={{fontWeight: 'bold'}}>Payment Allocation</label>
                    {' '}<ActionLink onClick={this.payFill}
                                     title="Pay the first booking off in full first, then 2nd booking, and so forth">FillDown</ActionLink>
                    {' '}<ActionLink onClick={this.payDist}
                                     title="Split total payment amount based on amount owing">Distribute</ActionLink>
                    {' '}<ActionLink onClick={this.paySplit}
                                     title="Divide total payment evenly among bookings. If amount owing is less, funds may remain unallocated.">SplitEvenly</ActionLink>
                </div>
                <table className="simple-table">
                    <tbody>
                        {bookings.map((bk: any) => <tr key={bk.id}>
                            <td style={{width: '125px', verticalAlign: 'middle'}}><a
                                href={resolveRoute('bookings.show', {id: bk.id})}
                                target="_blank" rel="noreferrer">#{bk.number}</a> ({bk.total_due})
                            </td>
                            <td>
                                <div key="hourly_rate_textbox_container" className="textbox-and-slider">
                                    <div className="tas-textbox">
                                        <DollarBox
                                            onChange={(ev: any) => setAlloc(bk.id, ev.target.value)}
                                            value={getAlloc(bk.id)}
                                            disabled={!chargeAmount}/>
                                    </div>
                                    <div className="tas-slider">
                                        <Slider value={getAlloc(bk.id)}
                                                onSlide={(ev, ui) => setAlloc(bk.id, ui.value.toFixed(2))}
                                                min={0} max={Math.min(chargeAmount, bk.total_due_value)} step={0.01}
                                                disabled={!chargeAmount}/>
                                    </div>
                                </div>
                            </td>
                        </tr>)}
                        <tr>
                            <th>Total</th>
                            <td>{this.allocDiff == 0 ? <Fragment>${this.totalAlloc}</Fragment> : <Fragment><span
                                style={{color: 'red'}}>${this.totalAlloc}</span> (${Math.abs(this.allocDiff).toFixed(2)} {this.allocDiff > 0 ? 'unallocated' : 'over-allocated'})</Fragment>}</td>
                        </tr>
                    </tbody>
                </table>

            </Fragment>
        );
    }
}
